/*
 * ALLPOWERS DE – Global Tiered Free Gift
 * Version: 1.1.0 SAFE
 *
 * Gift tiers (highest eligible tier only):
 * €1,200–€1,599.99  -> SE60
 * €1,600–€2,199.99  -> P100
 * €2,200–€3,199.99  -> S200
 * €3,200+            -> S300
 *
 * IMPORTANT:
 * This script manages which gift is in the Shopify cart.
 * The gift price must be made FREE by Shopify automatic Buy X Get Y discounts.
 */
(function () {
  'use strict';

  if (window.AP_TIERED_GIFT_LOADED) return;
  window.AP_TIERED_GIFT_LOADED = true;

  const CONFIG = {
    enabled: true,
    currency: 'EUR',
    locale: 'de-DE',
    giftProperty: '_ap_free_gift',
    giftTierProperty: '_ap_gift_tier',
    giftNameProperty: '_ap_gift_name',
    tiers: [
      { threshold: 120000, variantId: 54623720603916, name: 'SE60', label: '60W Solarpanel SE60' },
      { threshold: 160000, variantId: 54365110632716, name: 'P100', label: 'P100 Powerbank' },
      { threshold: 220000, variantId: 43906400256268, name: 'S200', label: 'S200 Tragbare Powerstation' },
      { threshold: 320000, variantId: 43906400878860, name: 'S300', label: 'S300 Tragbare Powerstation' }
    ],
    text: {
      heading: 'Ihr Gratisgeschenk',
      unlocked: 'Gratisgeschenk freigeschaltet',
      highestUnlocked: 'Höchste Geschenkstufe erreicht',
      nextPrefix: 'Noch',
      nextSuffix: 'bis zum nächsten Gratisgeschenk',
      firstSuffix: 'bis zu Ihrem Gratisgeschenk',
      badge: 'GRATISGESCHENK',
      syncing: 'Geschenk wird aktualisiert …'
    }
  };

  const nativeFetch = window.fetch.bind(window);
  let isProcessing = false;
  let pendingCheck = false;
  let debounceTimer = null;
  let lastCart = null;

  function rootUrl(path) {
    const root = (window.routes && window.routes.root_url) || '/';
    return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
  }

  async function fetchJSON(url, options) {
    const response = await nativeFetch(url, options);
    if (!response.ok) {
      let detail = '';
      try { detail = await response.text(); } catch (e) {}
      throw new Error('Shopify request failed (' + response.status + '): ' + detail);
    }
    return response.json();
  }

  async function getCart() {
    return fetchJSON(rootUrl('cart.js'), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
  }

  function isManagedGift(item) {
    return !!(
      item &&
      item.properties &&
      String(item.properties[CONFIG.giftProperty]) === '1'
    );
  }

  function qualifyingSubtotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      if (isManagedGift(item)) return total;
      return total + Number(item.original_line_price || 0);
    }, 0);
  }

  function targetTierFor(subtotal) {
    let target = null;
    CONFIG.tiers.forEach(function (tier) {
      if (subtotal >= tier.threshold) target = tier;
    });
    return target;
  }

  function nextTierFor(subtotal) {
    return CONFIG.tiers.find(function (tier) {
      return subtotal < tier.threshold;
    }) || null;
  }

  async function changeLine(lineKey, quantity) {
    return fetchJSON(rootUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
  }

  async function addGift(tier) {
    const properties = {};
    properties[CONFIG.giftProperty] = '1';
    properties[CONFIG.giftTierProperty] = String(tier.threshold / 100);
    properties[CONFIG.giftNameProperty] = tier.name;

    return fetchJSON(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: tier.variantId,
          quantity: 1,
          properties: properties
        }]
      })
    });
  }

  async function removeLines(lines) {
    for (const item of lines) {
      await changeLine(item.key, 0);
    }
  }

  async function refreshThemeCart() {
    try {
      if (window.SHTHelper && typeof window.SHTHelper.forceUpdateCartStatus === 'function') {
        await window.SHTHelper.forceUpdateCartStatus();
        return;
      }
    } catch (e) {
      console.warn('[AP Gift] Theme cart refresh fallback used.', e);
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: lastCart } }));
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(CONFIG.locale, {
        style: 'currency',
        currency: CONFIG.currency,
        minimumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '€' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function progressPercent(subtotal) {
    const first = CONFIG.tiers[0].threshold;
    const highest = CONFIG.tiers[CONFIG.tiers.length - 1].threshold;
    if (subtotal <= 0) return 0;
    if (subtotal >= highest) return 100;

    let lower = 0;
    let upper = first;
    for (let i = 0; i < CONFIG.tiers.length; i++) {
      if (subtotal < CONFIG.tiers[i].threshold) {
        upper = CONFIG.tiers[i].threshold;
        lower = i === 0 ? 0 : CONFIG.tiers[i - 1].threshold;
        break;
      }
    }
    const segmentStart = (CONFIG.tiers.findIndex(t => t.threshold === upper)) * (100 / CONFIG.tiers.length);
    const segmentWidth = 100 / CONFIG.tiers.length;
    const local = Math.max(0, Math.min(1, (subtotal - lower) / (upper - lower)));
    return Math.min(100, segmentStart + local * segmentWidth);
  }

  function buildStatusMarkup(cart) {
    const subtotal = qualifyingSubtotal(cart);
    const current = targetTierFor(subtotal);
    const next = nextTierFor(subtotal);
    let message = '';
    let giftLine = '';

    if (!current) {
      const remaining = CONFIG.tiers[0].threshold - subtotal;
      message = '<strong>' + CONFIG.text.nextPrefix + ' ' + money(remaining) + '</strong> ' + CONFIG.text.firstSuffix + '.';
      giftLine = 'Ab ' + money(CONFIG.tiers[0].threshold) + ': ' + CONFIG.tiers[0].label + ' gratis.';
    } else if (next) {
      const remaining = next.threshold - subtotal;
      message = '<strong>🎁 ' + current.label + ' ' + CONFIG.text.unlocked + '.</strong>';
      giftLine = CONFIG.text.nextPrefix + ' ' + money(remaining) + ' ' + CONFIG.text.nextSuffix + ': <strong>' + next.label + '</strong>.';
    } else {
      message = '<strong>🎁 ' + current.label + ' – ' + CONFIG.text.highestUnlocked + '.</strong>';
      giftLine = 'Pro Bestellung wird nur das Geschenk der höchsten erreichten Stufe gewährt.';
    }

    return '' +
      '<div class="ap-tiered-gift-status" data-ap-tiered-gift-status>' +
        '<div class="ap-tiered-gift-status__top">' +
          '<span class="ap-tiered-gift-status__title">' + CONFIG.text.heading + '</span>' +
          '<span class="ap-tiered-gift-status__amount">' + money(subtotal) + '</span>' +
        '</div>' +
        '<div class="ap-tiered-gift-progress" aria-hidden="true">' +
          '<span class="ap-tiered-gift-progress__fill" style="width:' + progressPercent(subtotal).toFixed(2) + '%"></span>' +
        '</div>' +
        '<div class="ap-tiered-gift-status__message">' + message + '</div>' +
        '<div class="ap-tiered-gift-status__next">' + giftLine + '</div>' +
      '</div>';
  }

  function insertStatus(container, cart) {
    if (!container || !cart) return;
    const old = container.querySelector('[data-ap-tiered-gift-status]');
    if (old) old.remove();
    container.insertAdjacentHTML('afterbegin', buildStatusMarkup(cart));
  }

  function decorateGiftLines(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach(function (item, index) {
      if (!isManagedGift(item)) return;

      const lineNumber = index + 1;
      const drawerLine = document.getElementById('cartDrawerItem-' + lineNumber);
      const mainLine = document.getElementById('cartItem-' + lineNumber);

      [drawerLine, mainLine].forEach(function (line) {
        if (!line) return;
        line.classList.add('ap-tiered-gift-line');

        const titleWrap = line.querySelector('.cart-drawer__product-info--title') || line.querySelector('.cart-item__details') || line;
        if (titleWrap && !titleWrap.querySelector('.ap-tiered-gift-badge')) {
          titleWrap.insertAdjacentHTML('afterbegin', '<span class="ap-tiered-gift-badge">' + CONFIG.text.badge + '</span>');
        }

        line.querySelectorAll('sht-cart-drwr-qty-inp, sht-cart-drwr-rmv-btn, sht-cart-qty-inp, sht-cart-rmv-btn').forEach(function (el) {
          el.classList.add('ap-tiered-gift-controls-hidden');
        });
      });
    });
  }

  function renderUI(cart) {
    if (!cart) return;

    const drawerFooter = document.querySelector('#cartDrawer .cart-drawer__footer');
    insertStatus(drawerFooter, cart);

    const mainCartFooter = document.querySelector('#mainCartContainer .js-cart-form-footer') || document.querySelector('#mainCartContainer');
    if (mainCartFooter) insertStatus(mainCartFooter, cart);

    decorateGiftLines(cart);
  }

  function announce(cart, tier) {
    document.dispatchEvent(new CustomEvent('ap:gift-updated', {
      detail: { cart: cart, tier: tier }
    }));
  }

  async function reconcileGift(options) {
    options = options || {};
    if (!CONFIG.enabled) return null;

    if (isProcessing) {
      pendingCheck = true;
      return lastCart;
    }

    isProcessing = true;
    document.documentElement.classList.add('ap-tiered-gift-syncing');

    let changed = false;

    try {
      let cart = await getCart();
      const subtotal = qualifyingSubtotal(cart);
      const targetTier = targetTierFor(subtotal);
      const managed = cart.items.filter(isManagedGift);

      if (!targetTier) {
        if (managed.length) {
          await removeLines(managed);
          changed = true;
          cart = await getCart();
        }
      } else {
        const wrong = managed.filter(function (item) {
          return Number(item.variant_id) !== Number(targetTier.variantId);
        });

        if (wrong.length) {
          await removeLines(wrong);
          changed = true;
          cart = await getCart();
        }

        let correct = cart.items.filter(function (item) {
          return isManagedGift(item) && Number(item.variant_id) === Number(targetTier.variantId);
        });

        if (correct.length > 1) {
          await removeLines(correct.slice(1));
          changed = true;
          cart = await getCart();
          correct = cart.items.filter(function (item) {
            return isManagedGift(item) && Number(item.variant_id) === Number(targetTier.variantId);
          });
        }

        if (!correct.length) {
          await addGift(targetTier);
          changed = true;
          cart = await getCart();
        } else if (Number(correct[0].quantity) !== 1) {
          await changeLine(correct[0].key, 1);
          changed = true;
          cart = await getCart();
        }
      }

      lastCart = cart;

      if (changed && options.refreshTheme !== false) {
        await refreshThemeCart();
        // Theme section replacement is asynchronous; let the DOM settle before decoration.
        await new Promise(function (resolve) { setTimeout(resolve, 80); });
      }

      renderUI(cart);
      announce(cart, targetTierFor(qualifyingSubtotal(cart)));
      return cart;
    } catch (error) {
      console.error('[ALLPOWERS Tiered Gift]', error);
      return lastCart;
    } finally {
      isProcessing = false;
      document.documentElement.classList.remove('ap-tiered-gift-syncing');

      if (pendingCheck) {
        pendingCheck = false;
        setTimeout(function () { reconcileGift(); }, 120);
      }
    }
  }

  function schedule(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      reconcileGift();
    }, typeof delay === 'number' ? delay : 250);
  }

  // Watch all Shopify cart AJAX mutations used by product forms, cart drawer and cart page.
  window.fetch = async function () {
    const args = Array.prototype.slice.call(arguments);
    let url = '';

    try {
      if (typeof args[0] === 'string') url = args[0];
      else if (args[0] && args[0].url) url = args[0].url;
    } catch (e) {}

    const response = await nativeFetch.apply(window, args);

    const isMutation =
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1;

    if (isMutation && !isProcessing) schedule(180);
    return response;
  };

  // Before checkout, perform one final gift sync so an outdated gift cannot pass through.
  document.addEventListener('click', function (event) {
    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!checkout || checkout.dataset.apGiftCheckoutReady === '1') return;

    event.preventDefault();
    event.stopPropagation();

    reconcileGift().finally(function () {
      checkout.dataset.apGiftCheckoutReady = '1';
      window.location.href = rootUrl('checkout');
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedule(120);
    });
  } else {
    schedule(120);
  }

  // Theme sections/modules may announce cart changes. Listen only to explicit cart events.
  // No page-wide MutationObserver is used, so unrelated images/sections are never watched or touched.
  document.addEventListener('cart:updated', function () { schedule(120); });
  document.addEventListener('shopify:section:load', function () {
    if (lastCart) renderUI(lastCart);
  });

  window.addEventListener('pageshow', function () { schedule(120); });

  window.AP_TIERED_GIFT = {
    refresh: reconcileGift,
    config: CONFIG,
    getCart: getCart
  };
})();
